import { pageSegment } from './action_tracker';
import { getSegmentActionTrackerKey } from './credentials';
import { trackableParams } from './params';

export function page(args) {
  let args_ = {
    ...args,
    ...trackableParams(),
  };
  return pageSegment(getSegmentActionTrackerKey(), args_);
}
